import { Grid } from '@mui/material';
import * as React from 'react';

import muiStyles from './styles';
import { WithdrawalInstructionsOptionRendererProps } from './types';

const WithdrawalInstructionsOptionRendererComponent = React.forwardRef((props: WithdrawalInstructionsOptionRendererProps, ref) => {
    const {
        innerProps,
        innerRef,
        getValue,
        data
    } = props;

    const classes = muiStyles(props);

    const optionRef = React.useRef<any>(innerRef);
    const instruction = data.refData;
    const currentValue = getValue().length === 1 && getValue()[0].value;
    let selected = false;
    if (currentValue === instruction.AccountWithdrawalDataId) {
        selected = true;
    }

    return (
        <Grid
            className={`${classes.root} ${selected ?
                classes.selected
                : classes.hover}`}
            container
            direction='column'
            ref={optionRef}
            spacing={0}
            wrap='nowrap'
            {...innerProps}
        >
            <div className={classes.InstructionOptionSelectWrapper}>
                <div className={classes.InstructionOptionSelect}>
                    <div className={`${classes.InstructionOptionSelect}__left`}>
                        <div className={classes.InstructionOption} >{instruction.Description}</div>
                    </div>
                </div>
            </div>
        </Grid>
    );
});

WithdrawalInstructionsOptionRendererComponent.displayName = 'WithdrawalInstructionsOptionRendererComponent';
export default WithdrawalInstructionsOptionRendererComponent;